module.exports = __webpack_public_path__ + "2c1d3ff110dd84c6febe1017fbcbc69e.png";